import { render, staticRenderFns } from "./DmBatches.vue?vue&type=template&id=71d99284&scoped=true&"
import script from "./DmBatches.vue?vue&type=script&lang=js&"
export * from "./DmBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d99284",
  null
  
)

export default component.exports